import styled from 'styled-components';
import { flexbox, flexShrink, justifyContent, flex } from '../../styles/helpers/flexbox';
import ThemeHelper from '../../themes/theme-helper';

const onDraggingStyle = isDragging => ({
    background: isDragging ? '#e7b300' : ''
});

const showElement = bool => ({
    display: bool ? '' : 'none'
});

const ChildWrapper = styled.div(() => `.childPanel {
           margin: 5px 0px 0px 10px;
        }`);

const ListItemWrapper = styled.div((props) => {
    const {
        colours,
        palette,
        typography
    } = ThemeHelper.getTheme(props);

    let backgroundColor = '#99ffff';
    let infoBorderColor = colours.silverDark;
    let infoBorderSize = '1px';
    let infoHeight = '48px';

    if (props.showGirlIcons) {
        backgroundColor = '#ffcccc';
    } else if (props.draggableId.indexOf('spine') !== -1) {
        backgroundColor = palette.primary.text;
    }
    if (props.isInvalid) {
        infoBorderColor = 'red';
        infoBorderSize = '6px';
        infoHeight = '55px';
    }

    return `
        .info {
            ${flexbox()}
            height: ${infoHeight};
            border: ${infoBorderSize} solid ${infoBorderColor};
            border-radius: 7px;
            box-shadow: 10px 5px 5px rgba(0, 0, 0, 0.1);
            background: ${backgroundColor};
            cursor: pointer;
            outline: none;
        }

        .moveIcon {
            width: 24px;
            height: 25px;
            ${flexShrink(0)}
            padding-top: 12px;
            padding-left: 5px;
            cursor: pointer;
        }

        .name {
            ${flexShrink(0)}
            ${justifyContent('space-between')}
            ${flex('1')}
            padding-left: 5px;
            color: ${colours.emperor};
            font-family: ${typography.family};
            padding-top: 13px;
            font-size: 14px;
            font-weight: 500;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            outline: none;
        }

        .nameNonEditable {
            ${flexShrink(0)}
            ${flex(1)};
            padding-left: 5px;
            color: ${colours.emperor};
            font-family: ${typography.family};
            padding-top: 13px;
            font-size: 14px;
            font-weight: 500;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            outline: none;
        }

        .iconPanel {
            padding-top: 12px;
            ${flexbox()}
            ${flexShrink(0)}
            ${justifyContent('space-evenly')}
        }

        .iconStyle {
            width: 18px;
            height: 25px;
            margin-right:4px;
            outline: none;
            cursor: pointer;
        }

        .previewStyle {
            width: 18px;
            height: 25px;
            padding-top: 3px;
            margin-right:4px;
            outline: none;
            cursor: pointer;
        }

        .toggle {
            height: 25px;
            margin-right:4px;
            outline: none;
            cursor: pointer;
        }

        .tree {
            height: 100%;
            overflow: auto;
        }

        .node {
            padding: 6px;
        }
    `;
});

const InputWrapper = styled.div`
    ${flexbox()}

    .icon {
        width: 20px;
        height: 21px;
        margin: 0 10px;
        float: right;
        cursor: pointer;
        outline: none;

        svg {
            path { fill: #8b8b8b !important; }
        }
    }
`;

const ListItemInfo = styled.div((props) => {
    const { colours, palette } = ThemeHelper.getTheme(props);
    return `
            ${flexbox()}
            height: 48px;
            border: 1px solid ${colours.silverDark};
            border-radius: 7px;
            box-shadow: 10px 5px 5px rgba(0, 0, 0, 0.1);
            background-color: ${palette.primary.text};
        `;
});

const TreeWrapper = styled.div((props) => {
    const { palette } = ThemeHelper.getTheme(props);
    return `
        .tree {
            height: 100%;
            overflow: auto;
        }

        .dropZone {
            min-height: 100px;
        }

        .node {
            padding: 6px;
        }

        .dropZone {
            height: 5px;

            &:hover {
                border: 2px solid ${palette.primary.light};
                border-style: dashed;
            }
        }
    `;
});

export { ListItemInfo, onDraggingStyle, ListItemWrapper, showElement, ChildWrapper, TreeWrapper, InputWrapper };



// WEBPACK FOOTER //
// ./app/components/list-item/styled.js